import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HeaderService } from '../Services/header.service';

@Component({
  selector: 'deploy-calendar',
  templateUrl: './deploy-calendar.component.html',
  styleUrls: ['../app.component.scss'],
  providers: []
})
export class DeployCalendarComponent implements OnInit {

  constructor(private headerService: HeaderService, protected Sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {

  }
}


